import http from '../clients/Axios'

export default class DepartemenService {
  async paginate(
    pageNumber,
    pageSize = 10,
    sortField,
    sortOrder,
    parent_id = 0,
    filters
  ) {
    pageNumber = pageNumber === undefined ? 1 : pageNumber
    const sort = sortOrder === 1 ? '-' + sortField : sortField
    let filters_param = `page=${pageNumber}&size=${pageSize}&sort=${sort}`
    if (parent_id > 0) {
      filters_param = filters_param + '&parent_id=' + parent_id
    }

    if (filters) {
      const keys = Object.keys(filters)

      keys.forEach((el) => {
        if (filters[el].value) {
          if (el === 'ctg' || el === 'name') {
            filters_param =
              filters_param + '&' + el + '=' + filters[el].value.trim()
          } else {
            filters_param = filters_param + '&' + el + '=' + filters[el].value
          }
        }
      })
    }

    const res = await http.get(`/department/paginate?${filters_param}`)

    return res.data
  }

  async get() {
    const res = await http.get('/department?sort=name')
    return res.data
  }

  async getById(param) {
    param = param ? param : ''
    const res = await http.get(`/department${param}`)
    return res
  }

  async getList(parent_id = '', keyword = '') {
    let res
    if (!parent_id) {
      res = await http.get(`/department?&name=${keyword}&sort=name`)
    } else {
      res = await http.get(
        `/department?parent_id=${parent_id}&name=${keyword}&sort=name`
      )
    }
    return res.data
  }

  async add(form) {
    const res = await http.post('/department', form)
    return res
  }

  async update(id, form) {
    const res = await http.put(`/department/${id}`, form)
    return res
  }

  async delete(id) {
    const res = await http.delete(`/department/${id}`)
    return res
  }

  async generateCode(id) {
    const res = await http.get(`/department/generate-code?parent_id=${id}`)
    return res.data
  }
}
